<template>
	<div>

		<v-overlay :value="isLoadingAction">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>

		<div
			style="background-color: #eee"
		>
			<div
				:class="`_box_title ${!gameday.gameday_passato || 'gameday_passato'}`"
				:style="`${
					(
						(computedAmIAdmin && computedClienteClickdayIt && !gameday.gameday_passato)
						|| computedAmIDeveloper
					)
					&& gameday.test_mode
					? `background-color: ${scdGreen}`
					: ''
				}`"
			>
				<span class="mr-1">{{ gameday.nome }}</span>
				<span v-if="gameday.test_mode">(Solo Admin o Dev)</span>
			</div>
			<div
				style="background-color: white"
				class="pa-3 mb-6"
			>
				<v-row v-if="gameday.gameday_di_oggi">
					<v-col class="d-flex justify-center">
						<div :style="`background-color:${scdRed}; color:white`" class="font-weight-bold py-1 px-4">
							GAME DAY DI OGGI
						</div>
					</v-col>
				</v-row>
				<v-row class="justify-space-between pt-5 px-6 pb-4">
					<!--<v-progress-linear v-if="gameday.is_loading" class="mt-0 pt-0" :indeterminate="true" :color="scdColor"></v-progress-linear>-->
					<v-col cols="7" class="d-flex flex-column">
						<div class="font-weight-bold mb-3" style="font-size: 18px">
							Data Game Day: <span :style="`color:${scdColorStrong};`">{{ computedDateTime(gameday.data_ora) }}</span>
						</div>
						<div style="font-size: 14px;" class="font-weight-bold">
							<div>Compenso in caso di vittoria del Game Day:
								<span :style="`color:${scdColorStrong};`">{{ gameday.compenso_gameday_vinto_clickday_perso }}/{{ gameday.compenso_gameday_vinto_clickday_vinto }}€</span>
							</div>
							<div>Compenso in caso di perdita del Game Day:
								<span :style="`color:${scdColorStrong};`">{{ gameday.compenso_gameday_perso_clickday_perso }}/{{ gameday.compenso_gameday_perso_clickday_vinto }}€</span>
							</div>
							<div>Punti in classifica per vittoria del Game Day:
								<span :style="`color:${scdColorStrong};`">{{ gameday.punti_gameday_vinto }}</span>
							</div>
							<div>Punti in classifica per perdita del Game Day:
								<span :style="`color:${scdColorStrong};`">{{ gameday.punti_gameday_perso }}</span>
							</div>
							<div>Punti in classifica per abbandono del Game Day:
								<span :style="`color:${scdColorStrong};`">{{ gameday.punti_gameday_abbandonato }}</span>
							</div>
						</div>
						<div class="d-flex mt-4">
							<div>
								<v-btn
									rounded
									depressed
									style="text-transform:none; color:white;"
									@click="apriDialogClassificaGameDay()"
									:color="scdOrange"
								>
									Visualizza classifica
								</v-btn>
							</div>
							<div v-if="gameday.gameday_passato || (computedAmIAdmin && computedClienteClickdayIt) || computedAmIDeveloper" class="ml-3">
								<v-btn
									rounded
									depressed
									style="text-transform:none; color:white;"
									@click="vaiAlGameday(gameday, true)"
									:color="(computedAmIAdmin && computedClienteClickdayIt && !gameday.gameday_passato) || computedAmIDeveloper ? scdGreen : scdOrange"
								>
									<span class="mr-1">Guarda il Game Day</span>
									<span v-if="(computedAmIAdmin && computedClienteClickdayIt && !gameday.gameday_passato) || computedAmIDeveloper">(Solo Admin o Dev)</span>
								</v-btn>
							</div>
						</div>
						
						<div
							v-if="(amIAdminOrTeamleader || computedAmIDeveloper) && computedClienteClickdayIt && !idCliccatore"
							class="d-flex mt-4"
						>
							<div v-if="computedAmIDeveloper || amIAdminOrTeamleader">
								<v-btn
									rounded
									depressed
									style="text-transform:none; color:white;"
									@click="apriDialogGestioneScreenshotsEdEsiti()"
									:color="scdGreen"
								>
									Gestione Screenshots ed Esiti
								</v-btn>
							</div>
							<!--<div v-if="computedAmIDeveloper || computedAmIAdmin" class="ml-3">-->
							<!--	<v-btn-->
							<!--		rounded-->
							<!--		depressed-->
							<!--		style="text-transform:none; color:white;"-->
							<!--		@click="apriDialogMonitoraggioScreenshotsEdEsitiGameDay(gameday)"-->
							<!--		:color="scdGreen"-->
							<!--	>-->
							<!--		Monitoraggio Screenshots ed Esiti-->
							<!--	</v-btn>-->
							<!--</div>-->
						</div>
					</v-col>

					<v-col cols="5">
						<div v-if="!gameday.cliccatore_iscritto_al_gameday" class="d-flex flex-column align-center">
							<v-btn
								v-if="!gameday.gameday_passato"
								rounded
								depressed
								style="text-transform:none; color:white;"
								@click="apriDialogIscrizioneGameday()"
								:color="scdOrange"
								x-large
							>
								Iscriviti a questo Game Day
							</v-btn>
							<div class="mt-2 font-weight-medium">
								<div>Scadenza iscrizione:</div>
								<div>{{ computedDateTime(gameday.data_ora_scadenza_iscrizione) }}</div>
							</div>
						</div>
						<div v-else-if="gameday.cliccatore_iscritto_al_gameday && gameday.esito_gameday == null" class="text-center">
							<v-btn
								v-if="computedClienteClickdayIt && amIAdminOrTeamleader"
								rounded
								depressed
								style="color:white;"
								@click="annullaIscrizioneCliccatoreAlGameDay(gameday)"
								:color="scdRed"
								class="mb-4"
							>
								Annulla iscrizione a questo Game Day
							</v-btn>
							<v-btn
								rounded
								depressed
								class="ml-2"
								style="text-transform:none; color:white;"
								@click="vaiAlGameday(gameday)"
								:color="scdOrange"
								x-large
							>
								Vai al Game Day
							</v-btn>
						</div>
						<div
							v-else-if="gameday.cliccatore_iscritto_al_gameday"
							class="d-flex flex-column "
							style="padding:25px 20px; min-width:259px; background-color: #e3ebf6; border-radius: 10px"
						>
							<div class="d-flex align-center mb-2">
								<div style="font-weight:700; font-size:20px;" class="mr-2 flex-grow-1">
									<v-row v-if="gameday.esito_gameday === 'vincente'" :style="`color:${scdGreen};`" class="align-center no-gutters">
										<v-col cols="1" class="mr-3">
											<v-icon class="icon-outlined" size="19" :style="`border-color: ${scdGreen}`" :color="scdGreen">mdi-trophy-variant-outline</v-icon>
										</v-col>
										<v-col><div>Hai vinto!</div></v-col>
									</v-row>

									<v-row v-else-if="gameday.esito_gameday === 'non_vincente'" :style="`color:${scdLightRed};`" class="align-center no-gutters">
										<v-col cols="1" class="mr-3">
											<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdLightRed}`" :color="scdLightRed">close</v-icon>
										</v-col>
										<v-col><div>Non hai vinto</div></v-col>
									</v-row>

									<v-row v-else-if="gameday.esito_gameday === 'in_attesa_di_esito'" :style="`color:${scdColorDarkBlue};`" class="align-center no-gutters">
										<v-col cols="1" class="mr-3">
											<v-icon class="icon-outlined" size="20" :color="scdColorDarkBlue">hourglass_bottom</v-icon>
										</v-col>
										<v-col><div>In attesa di esito</div></v-col>
									</v-row>

									<v-row v-else-if="gameday.esito_gameday === 'abbandonato'" :style="`color:${scdRed};`" class="align-center no-gutters">
										<v-col cols="1" class="mr-3">
											<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdRed}`" :color="scdRed">block</v-icon>
										</v-col>
										<v-col><div>Abbandonato</div></v-col>
									</v-row>
									
									<v-row v-else-if="gameday.esito_gameday === 'errore_screenshot'" :style="`color:${scdRed};`" class="align-center no-gutters">
										<v-col cols="1" class="mr-3">
											<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdRed}`" :color="scdRed">block</v-icon>
										</v-col>
										<v-col><div>Errore screenshot</div></v-col>
									</v-row>

									<!--<v-row v-else-if="gameday.esito_gameday === null" :style="`color:${scdOrange};`" class="align-center no-gutters">-->
									<!--	<v-col cols="1" class="mr-3"><v-icon class="icon-outlined" :style="`border-color: ${scdOrange}`" size="20" :color="scdOrange">mdi-account-plus-outline</v-icon></v-col>-->
									<!--	<v-col><div>Sei iscritto a questo Game Day</div></v-col>-->
									<!--</v-row>-->
								</div>
								<v-icon
									v-if="amIAdminOrTeamleader"
									:color="scdColor"
									small
									@click="apriDialogEsitoGameDay(gameday)"
								>
									edit
								</v-icon>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Il tuo tempo è:</span>
								<span :style="`font-weight:600; color:${scdColorStrong};`"> {{ gameday.tempo }}</span>
							</div>
						</div>
					</v-col>
				</v-row>
			</div>
		</div>

		<v-dialog persistent v-model="esitoGameDayDialog" max-width="504px">
			<v-card>
				<v-card-title>
					<span class="primary--text">Modifica Stato Game Day</span>
				</v-card-title>
				<v-card-text>
					<v-select
						:items="opzioniEsitoGameDay"
						v-model="gameDayToEdit.esito_gameday"
						placeholder="Seleziona"
						outlined
						dense
					></v-select>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						depressed
						rounded
						:color="scdColor"
						style="color:white; text-transform:none;"
						class="px-6"
						@click="esitoGameDayDialog = false"
					>
						Annulla
					</v-btn>
					<v-btn
						:color="scdOrange"
						class="white--text px-6"
						:loading="salvataggioEsitoGameDay"
						depressed
						rounded
						style="color:white; text-transform:none;"
						@click="salvaEsitoGameDay()"
					>
						Salva
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogClassificaGameDay" width="unset" scrollable>
			<v-card>
				<v-card-title>
					<span class="primary--text">Classifica {{ gameday.nome }} - {{ gameday.data_ora }}</span>
				</v-card-title>
				<v-card-text>
					<v-data-table
						:headers="headersClassificaGameday"
						:items="classificaGameday"
						loading-text="In caricamento.."
						:loading="isLoadingClassificaGameDay"
						no-data-text="Nessun cliccatore"
						:footer-props="{
							'items-per-page-options':[50, 100, 200, 500, -1],
							'items-per-page-text': 'Cliccatori per pagina'
						}"
						sort-by="tempo"
						:custom-sort="customSort"
						style="background-color: white; border-radius: 0"
						class="classifica-game-day-data-table"
						dense
						:options="{
							itemsPerPage: -1,
						}"
					>
						<template slot="item" slot-scope="props">
							<tr :style="`color: ${scdColor}; ${ props.item.riga_da_evidenziare ? 'background-color: rgba(230, 144, 28, .5);' : null }`">
								<td class="font-weight-medium">{{ props.item.posizione_classifica }}°</td>
								<td class="font-weight-medium">{{ props.item.codice_cliccatore }}</td>
								<td class="font-weight-medium">{{ props.item.tempo }}</td>
								<td class="font-weight-medium">
									<span v-if="props.item.esito_gameday === 'vincente'" style="color:#8bba40;">Vincente!</span>
									<span v-else-if="props.item.esito_gameday === 'non_vincente'" style="color:#bc2025;">Non vincente</span>
									<span v-else-if="props.item.esito_gameday === 'in_attesa_di_esito'" :style="`color:${scdColor};`">In attesa di esito</span>
									<span v-else-if="props.item.esito_gameday === 'abbandonato'" style="color:#bc2025;">Abbandonato</span>
									<span v-else-if="props.item.esito_gameday === 'errore_screenshot'" style="color:#bc2025;">Errore screenshot</span>
									<span v-else-if="props.item.esito_gameday === null" :style="`color:${scdColor};`">Iscritto</span>
								</td>
								<td class="font-weight-medium">{{ props.item.nome_squadra || 'Senza Squadra' }}</td>
							</tr>
						</template>
						<template v-slot:footer.prepend>
							<div class="d-flex align-center">
								<v-btn
									v-if="computedClienteClickdayIt && computedAmIAdmin"
									@click="apriPubblicaClassificaDialog()"
									rounded
									depressed
									small
									color="secondary"
									class="ml-md-auto mr-3 white--text"
								>
									Pubblica classifica
								</v-btn>
							</div>
						</template>
					</v-data-table>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						depressed
						rounded
						:color="scdColor"
						style="color:white; text-transform:none;"
						class="px-6"
						@click="dialogClassificaGameDay = false"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="errorDialog" width="unset" persistent>
			<v-card>
				<v-card-title>
					{{ errorMessage }}
				</v-card-title>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="errorDialog = false"
						:color="scdColor"
						class="px-2"
					>
						Ok
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogIscrizioneGameday" width="1100px" persistent>
			<v-card>
				<v-card-title class="font-weight-bold" :style="`color:${scdColorDarkBlue}`">
					Sei sicuro di voler iscriverti al Game Day?
				</v-card-title>
				<v-card-text class="font-weight-medium" style="font-size: 16px">
					<p>Cliccando sul tasto "<span class="font-weight-bold" :style="`color:${scdOrange}`">Si, iscrivimi</span>" sarai iscritto al <span class="font-weight-bold">{{ gameday.nome }} del {{ computedDateWithoutTime(gameday.data_ora) }} alle ore {{ computedTimeWithoutSeconds(gameday.data_ora) }}</span>.</p>
					<p><span class="font-weight-bold" :style="`color:${scdRed}`">ATTENZIONE:</span> una volta iscritto al Game Day equivale ad avere un'azienda assegnata al vero Click Day, per cui <span class="font-weight-bold">è obbligatorio essere presenti</span>. Se non sei sicuro per qualsiasi motivo, non iscriverti finchè non lo sei e, se hai bisogno di aiuto, scrivi al tuo Coordinatore su Telegram.</p>
					<p>Se dopo l'iscrizione non potessi più partecipare, il tuo stato risulterebbe "<span class="font-weight-bold" :style="`color:${scdRed}`">Abbandonato</span>", perdendo quindi {{ Math.abs(gameday.punti_gameday_abbandonato) }} punti e rischiando di essere escluso dal vero Click Day.</p>
					<p>Vuoi continuare?</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="dialogIscrizioneGameday = false"
						:color="scdColor"
						class="px-4"
					>
						Annulla
					</v-btn>
					<v-btn
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="checkCompatibilityBrowserVersion()"
						:color="scdOrange"
						class="px-4"
					>
						Si, iscrivimi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="dialogGestioneScreenshotsEdEsitiGameDay"
			persistent
			scrollable
		>
			<v-card>
				<v-card-title class="font-weight-bold" :style="`color:${scdColorDarkBlue}`">
					Gestione Screenshot ed Esiti {{ gameday.nome }}
				</v-card-title>
				<v-card-text class="font-weight-medium" style="font-size: 16px">
					<v-row>
						<v-col cols="1">
							<v-btn
								color="secondary"
								rounded
								dark
								:loading="isLoadingIscritti"
								@click="getIscritti(idSquadraSelezionata)"
							>
								<v-icon>mdi-reload</v-icon>
							</v-btn>
						</v-col>
						<v-col cols="4">
							<v-select
								class="pt-0"
								item-text="nome"
								item-value="id"
								:items="squadre"
								v-model="idSquadraSelezionata"
								placeholder="Seleziona"
								:loading="isLoadingSquadre"
								:disabled="isLoadingIscritti"
								clearable
								@click:clear="idSquadraSelezionata = null; getIscritti()"
								hide-details
								outlined
								dense
							></v-select>
						</v-col>
						<v-col>
						
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-data-table
								:headers="headersGestioneScreenshotsEdEsiti"
								:items="cliccatoriIscritti"
								loading-text="In caricamento.."
								:loading="isLoadingIscritti"
								no-data-text="Nessun cliccatore"
								:footer-props="{
							'items-per-page-options':[50, 100, 200, 500, -1],
							'items-per-page-text': 'Cliccatori per pagina'
						}"
								sort-by="codice_cliccatore"
								style="background-color: white; border-radius: 0"
								class="gestione-screenshots-ed-esiti-game-day-data-table"
								dense
								:options="{
							itemsPerPage: -1,
						}"
							>
								<!--<template v-slot:item.stato_screenshot="{ item }">-->
								<!--	<v-radio-group-->
								<!--		v-model="item.pivot.stato_screenshot"-->
								<!--		@change="salvaStatoScreenshot(item)"-->
								<!--		:disabled="item.isSavingStatoScreenshot"-->
								<!--		class="my-1 pt-0"-->
								<!--		hide-details-->
								<!--		row-->
								<!--	>-->
								<!--		<v-radio-->
								<!--			v-for="(stato, index) in statiScreenshot"-->
								<!--			:key="index"-->
								<!--			:label="stato"-->
								<!--			:value="stato"-->
								<!--			:color="scdColor"-->
								<!--		></v-radio>-->
								<!--	</v-radio-group>-->
								<!--</template>-->
								<template v-slot:item.gestione_screenshot="{ item }">
									<div class="d-flex align-center">
										<!-- 1. Button that will be clicked to select a file -->
										<v-btn
											color="primary"
											rounded
											dark
											small
											class="mr-2"
											:loading="item.isSelectingScreenshot || item.isUploadingScreenshot"
											@click="handleFileImport(item)"
										>
											Carica
										</v-btn>
										<!-- File Input that will be hidden but triggered with JavaScript -->
										<input
											:ref="`uploader${item.id}`"
											class="d-none"
											type="file"
											accept="image/*"
											@change="onFileChanged($event, item)"
										>
										<!--accept="image/png, image/jpeg, image/jpg"-->
										
										<v-btn
											color="primary"
											rounded
											small
											:disabled="item.pivot.path_screenshot === null || item.isUploadingScreenshot"
											@click="apriAnteprimaScreenshotDialog(item)"
										>
											Visualizza
										</v-btn>
									</div>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="dialogGestioneScreenshotsEdEsitiGameDay = false"
						:color="scdColor"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="previewScreenshotDialog"
			persistent
			scrollable
		>
			<v-card>
				<v-card-title class="font-weight-bold" :style="`color:${scdColorDarkBlue}`">
					{{ previewScreenshotTitle }}
				</v-card-title>
				<v-card-text class="font-weight-medium" style="font-size: 16px">
					<v-progress-linear
						v-if="isLoadingBase64Screenshot"
						indeterminate
					></v-progress-linear>
					<v-img
						v-else
						:src="base64Screenshot"
						contain
					></v-img>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="previewScreenshotDialog = false"
						:color="scdColor"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="incompatibleBrowserDialog"
			persistent
			width="600"
		>
			<v-card>
				<v-card-title class="font-weight-bold" :style="`color:${scdRed}`">
					ATTENZIONE!<br>
					Browser non compatibile!
				</v-card-title>
				<v-card-text class="font-weight-medium" style="font-size: 16px">
					Il browser che stai utilizzando non rientra in quelli compatibili.<br>
					<span v-if="checkBrowserBeforeGameday">Non puoi partecipare al Game Day</span>
					<span v-else-if="!checkBrowserBeforeGameday">Senza un browser compatibile non ti sarà permesso l'accesso al gameday, vuoi iscriverti ugualmente?</span>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="!checkBrowserBeforeGameday"
						rounded
						depressed
						style="text-transform:none; color:white;"
						@click="closeIncompatibleBrowserDialog()"
						:color="scdColor"
						class="px-4"
					>
						Annulla
					</v-btn>
					<v-btn
						v-if="checkBrowserBeforeGameday"
						rounded
						depressed
						style="text-transform:none; color:white;"
						:color="scdOrange"
						@click="closeIncompatibleBrowserDialog()"
						class="px-4"
					>
						Ho capito
					</v-btn>
					<v-btn
						v-else-if="!checkBrowserBeforeGameday"
						rounded
						depressed
						style="text-transform:none; color:white;"
						:color="scdOrange"
						@click="iscriviCliccatoreAlGameday()"
						class="px-4"
					>
						Si, iscrivimi al Game Day
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="pubblicaClassificaDialog"
			persistent
			scrollable
			width="unset"
		>
			<v-card>
				<v-card-title class="font-weight-bold" :style="`color:${scdColorDarkBlue}`">
					Pubblica classifica {{ gameday.nome }} - {{ computedDateTime(gameday.data_ora) }}
				</v-card-title>
				<v-card-text>
					<v-form ref="pubblicaClassificaGameDayForm">
						<v-text-field
							v-model="percentualeVincitori"
							label="Percentuale di vincitori"
							:rules="[vincoli.required]"
							outlined
							dense
							class="mt-3"
						></v-text-field>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						rounded
						depressed
						@click="pubblicaClassificaDialog = false"
						style="text-transform:none; color:white;"
						color="primary"
					>
						Annulla
					</v-btn>
					<v-btn
						rounded
						depressed
						@click="pubblicaClassifica()"
						:loading="pubblicazioneClassificaInCorso"
						style="text-transform:none; color:white;"
						color="secondary"
					>
						Pubblica
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
export default {
	props: ['gameday', 'idCliccatore', 'opzioniEsitoGameDay'],
	data() {
		return {
			// isSelecting: false,
			
			errorDialog: false,
			errorMessage: null,

			isLoadingAction: false,
			esitoGameDayDialog: false,
			// opzioniEsitoGameDay: [],
			gameDayToEdit: {
				utente_id: null,
				gameday_id: null,
				esito_gameday: null
			},
			salvataggioEsitoGameDay: false,
			dialogClassificaGameDay: false,
			isLoadingClassificaGameDay: false,
			headersClassificaGameday: [
				{ text: 'Posizione', value: 'posizione_classifica' },
				{ text: 'Codice cliccatore', value: 'codice_cliccatore' },
				{ text: 'Tempo', value: 'tempo' },
				{ text: 'Esito', value: 'esito_gameday' },
				{ text: 'Squadra', value: 'nome_squadra' },
			],
			classificaGameday: [],

			dialogIscrizioneGameday: false,
			
			isLoadingSquadre: null,
			squadre: [],
			idSquadraSelezionata: null,
			
			// class: (this.computedAmIDeveloper || this.computedAmIAdmin) ? '' : 'd-none',
			// cellClass: (this.computedAmIDeveloper || this.computedAmIAdmin) ? '' : 'd-none'
			
			isLoadingIscritti: false,
			headersGestioneScreenshotsEdEsiti: [
				{ text: 'Codice cliccatore', value: 'codice_cliccatore'},
				{ text: 'Username cliccatore', value: 'username' },
				{ text: 'Squadra', value: 'team.nome' },
				// { text: 'Stato Screenshot', value: 'stato_screenshot' },
				{ text: 'File Screenshot', value: 'gestione_screenshot' },
			],
			dialogGestioneScreenshotsEdEsitiGameDay: false,
			cliccatoriIscritti: [],
			cliccatoreIscrittoSelezionato: null,
			
			statiScreenshot: [
				'OK',
				'Errore',
				'Sbagliata',
				'Assente'
			],
			
			screenshot: null, // file di tipo immagine
			previewScreenshotDialog: false,
			previewScreenshotTitle: null,
			isLoadingBase64Screenshot: false,
			base64Screenshot: null,
			
			incompatibleBrowserDialog: false,
			checkBrowserBeforeGameday: false,
			
			pubblicaClassificaDialog: false,
			percentualeVincitori: null,
			pubblicazioneClassificaInCorso: false
		}
	},
	
	// created() {
	// 	this.isTheBrowserCompatible();
	// },
	
	watch: {
		idSquadraSelezionata(id) {
			this.getIscritti(id);
		}
	},
	
	methods: {
		apriDialogIscrizioneGameday() {
			this.dialogIscrizioneGameday = true;
		},
		checkCompatibilityBrowserVersion() {
			this.dialogIscrizioneGameday = false;
			
			if (!this.isTheBrowserCompatible()) {
				this.incompatibleBrowserDialog = true;
			}
			else {
				this.iscriviCliccatoreAlGameday();
			}
		},
		closeIncompatibleBrowserDialog() {
			this.incompatibleBrowserDialog = false;
			setTimeout(() => this.checkBrowserBeforeGameday = false, 500);
		},
		iscriviCliccatoreAlGameday() {
			this.dialogIscrizioneGameday = false;
			this.incompatibleBrowserDialog = false;
			this.isLoadingAction = true;
			axios.post('/clickdayit/gamedays/iscrizione', {
				gameday_id: this.gameday.gameday_id,
				cliccatore_id: this.idCliccatore
			})
				.then(async response => {
					await this.$emit('reload-gamedays')
					// await this.getGamedays();
				})
				.catch(error => {
					this.errorMessage = error.response.data.message;
					this.errorDialog = true;
				})
				.finally(() => {
					this.isLoadingAction = false;
				})
		},
		annullaIscrizioneCliccatoreAlGameDay(gameday) {
			this.isLoadingAction = true;
			axios.post('/clickdayit/gamedays/annulla-iscrizione', {
				gameday_id: gameday.gameday_id,
				cliccatore_id: this.idCliccatore
			})
				.then(async response => {
					await this.$emit('reload-gamedays')
					// await this.getGamedays();
				})
				.catch(error => {
					this.errorMessage = error.response.data.message;
					this.errorDialog = true;
				})
				.finally(() => {
					this.isLoadingAction = false;
				})
		},
		vaiAlGameday(gameday, onlyViewMode = false) {
			// if (!this.computedAmIDeveloper && !this.computedAmIAdmin) {
				if (!onlyViewMode) {
					if (!this.isTheBrowserCompatible()) {
						this.incompatibleBrowserDialog = true;
						this.checkBrowserBeforeGameday = true;
						return;
					}
				}
			// }
			
			this.isLoadingAction = true;
			let data = { id: gameday.gameday_id };
			if (onlyViewMode) data.only_view_mode = true;
			axios.post('/clickdayit/salva-dati-simulazione-gameday', data)
				.then(response => {
					if (onlyViewMode) window.location.href = `/game-day/${gameday.gameday_id}?only_view_mode=true`
					else window.location.href = `/game-day/${gameday.gameday_id}`
					// window.location.href = `/game-day/${gameday.gameday_id}`
				})
				.catch(error => {
					this.errorMessage = error.response.data.message;
					this.errorDialog = true;
				})
				.finally(() => {
					this.isLoadingAction = false;
				})
		},
		apriDialogEsitoGameDay(gameday) {
			this.esitoGameDayDialog = true;
			this.gameDayToEdit = Object.assign({}, gameday);
		},
		salvaEsitoGameDay() {
			this.salvataggioEsitoGameDay = true;
			axios.post('/clickdayit/gamedays/salva-esito-gameday', this.gameDayToEdit)
				.then(async response => {
					this.esitoGameDayDialog = false;
					this.isLoadingAction = true;
					// await this.getGamedays();
					await this.$emit('reload-gamedays')
					this.isLoadingAction = false;
				})
				.finally(() => {
					this.salvataggioEsitoGameDay = false;
				})
		},
		apriDialogClassificaGameDay() {
			this.dialogClassificaGameDay = true;
			this.getClassificaGameDay();
		},
		customSort(items, sortBy, sortDesc) {
			items.sort((a, b) => {
				if (a[sortBy] == b[sortBy]) return 0
				else if (a[sortBy] == null) return 1;
				else if (b[sortBy] == null) return -1;
				else if (!sortDesc[0]) return a[sortBy] < b[sortBy] ? -1 : 1;
				else return a[sortBy] < b[sortBy] ? 1 : -1;
			});
			return items;
		},
		gamedayProssimo(dataOra) {
			return moment(dataOra).isBefore(moment().add(20, 'minutes'))
		},
		getIscritti(idSquadra = null) {
			this.isLoadingIscritti = true;
			axios.get(`/clickdayit/gamedays/${this.gameday.gameday_id}/iscritti`, {
				params: {
					team_id: idSquadra
				}
			})
				.then(response => {
					this.cliccatoriIscritti = response.data;
					this.cliccatoriIscritti.forEach(cliccatore => {
						this.$set(cliccatore, "isSelectingScreenshot", false); // reactive
						this.$set(cliccatore, "isUploadingScreenshot", false); // reactive
						this.$set(cliccatore, "screenshot", null); // reactive
						this.$set(cliccatore, "isSavingStatoScreenshot", null); // reactive
					})
				})
				.finally(() => {
					this.isLoadingIscritti = false;
				})
		},
		uploadScreenshot(cliccatore) {
			cliccatore.isUploadingScreenshot = true;
			let formData = new FormData();
			formData.append('screenshot', cliccatore.screenshot);
			// formData.append('screenshot', this.screenshot);
			formData.append('cliccatore', JSON.stringify(cliccatore));
			formData.append('gameday', JSON.stringify(this.gameday));
			axios.post('/clickdayit/gamedays/upload-screenshot', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					cliccatore.pivot.path_screenshot = response.data;
				})
				.finally(() => {
					cliccatore.isUploadingScreenshot = false;
				})
		},
		handleFileImport(cliccatore) {
			cliccatore.isSelectingScreenshot = true;
			
			// this.cliccatoreIscrittoSelezionato = cliccatore;
			
			// After obtaining the focus when closing the FilePicker, return the button state to normal
			window.addEventListener('focus', () => {
				cliccatore.isSelectingScreenshot = false
			}, { once: true });
			
			// Trigger click on the FileInput
			this.$refs[`uploader${cliccatore.id}`].click();
		},
		onFileChanged(e, cliccatore) {
			cliccatore.screenshot = e.target.files[0];
			// Do whatever you need with the file, like reading it with FileReader
			this.uploadScreenshot(cliccatore);
		},
		apriDialogGestioneScreenshotsEdEsiti() {
			this.dialogGestioneScreenshotsEdEsitiGameDay = true;
			if (this.computedAmIAdmin || this.computedAmIDeveloper) {
				this.getSquadre();
			}
			this.getIscritti();
		},
		apriAnteprimaScreenshotDialog(cliccatore) {
			this.previewScreenshotDialog = true;
			this.previewScreenshotTitle = `Screenshot - ${cliccatore.codice_cliccatore || 'NESSUN CODICE CLICCATORE'}`
			this.getBase64Screenshot(cliccatore.pivot.path_screenshot);
		},
		getBase64Screenshot(path) {
			this.isLoadingBase64Screenshot = true;
			return axios.post('/storage/get-base-64-file', { path: path })
				.then(response => {
					this.base64Screenshot = response.data;
				})
				.finally(() => {
					this.isLoadingBase64Screenshot = false;
				})
		},
		salvaStatoScreenshot(cliccatore) {
			cliccatore.isSavingStatoScreenshot = true;
			axios.post('/clickdayit/gamedays/stato-screenshot', {
				cliccatore_id: cliccatore.id,
				gameday_id: this.gameday.gameday_id,
				// stato_screenshot: cliccatore.pivot.stato_screenshot,
			})
				.finally(() => {
					cliccatore.isSavingStatoScreenshot = false;
				})
		},
		getSquadre: function () {
			this.isLoadingSquadre = true;
			return axios.get("/teams")
				.then(response => {
					this.squadre = response.data.data;
					// this.squadre.unshift({
					// 	id: 0,
					// 	nome: "Squadra Principale"
					// });
				})
				.finally(() => {
					this.isLoadingSquadre = false;
				});
		},
		getClassificaGameDay() {
			this.isLoadingClassificaGameDay = true;
			const url = this.idCliccatore
				? `/clickdayit/gamedays/classifica-game-day/${this.gameday.gameday_id}/${this.idCliccatore}`
				: `/clickdayit/gamedays/classifica-game-day/${this.gameday.gameday_id}`
			
			axios.get(url)
				.then(response => {
					this.classificaGameday = response.data;
				})
				.finally(() => {
					this.isLoadingClassificaGameDay = false;
				})
		},
		apriPubblicaClassificaDialog() {
			this.pubblicaClassificaDialog = true;
		},
		pubblicaClassifica() {
			if (!this.$refs.pubblicaClassificaGameDayForm.validate()) return;
			
			this.pubblicazioneClassificaInCorso = true;
			axios.post('/clickdayit/gamedays/pubblica-classifica-gameday', {
				gameday_id: this.gameday.gameday_id,
				percentuale_vincitori: this.percentualeVincitori
			})
				.then(response => {
					this.pubblicaClassificaDialog = false;
					this.getClassificaGameDay();
				})
				.finally(() => {
					this.pubblicazioneClassificaInCorso = false;
				})
		}
	}
}
</script>

<style lang="scss" scoped>
._box_title {
	font-size: 16px;
	font-weight: 600;
	text-align:center;
	background-color: #6D94CD;
	padding: 5px 10px;
	color:white;
}

.gameday_passato {
	background-color: #acb5c2;
}

::v-deep .classifica-game-day-data-table,
::v-deep .gestione-screenshots-ed-esiti-game-day-data-table {
	background-color:#eeeeee;
	color: #434343 !important;
	& .v-data-table-header tr th {
			border-bottom: none !important;
			color: #fff !important;
			background-color: #6d94cd;
		}

	tbody tr:nth-of-type(even) {
		background-color: rgba(109, 148, 205, .15);
	}
}

.icon-outlined {
	background-color: white;
	border: 1px solid #3c4f6b;
	border-radius:50%;
	height: 30px;
	width: 30px;
}
</style>